import { QueryParam } from '../../Helpers'
import { IModalRouteQueryParam } from './types'

export const modalRouteClasses = {
  root: 'ModalRoute-root',
  content: 'ModalRoute-content',
  innerContent: 'ModalRoute-innerContent',
  fullHeight: 'ModalRoute-fullHeight',
  topbar: 'ModalRoute-topbar',
  topbarLeft: 'ModalRoute-topbarLeft',
  topbarRight: 'ModalRoute-topbarRight'
}

export const GetMRParam = () => {
  try {
    const md = QueryParam.Gets<IModalRouteQueryParam>('md').md
    return Array.isArray(md) ? md : md ? [md] : []
  } catch (error) {
    return []
  }
}

export const modalRouteSize = {
  heightHeader: 56,
  heightHeaderPx: '56px'
}

export type EMdStack = 'PopMdStack' | 'GoBack' | 'GoForward'

export const IsEMdStack = (value: any): value is EMdStack => {
  return value === 'PopMdStack' || value === 'GoBack' || value === 'GoForward'
}

type TOriginalEvent = React.MouseEvent<HTMLDivElement, MouseEvent> | React.MouseEvent<HTMLButtonElement, MouseEvent> | KeyboardEvent
export class EventClose extends CustomEvent<{ originalEvent: TOriginalEvent }> {}
export interface IEventMap {
  close: [EventClose]
}
